var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22.5","cy":"22.5","r":"22.5","fill":"#3BBB81","transform":"rotate(180 22.5 22.5)","key":0}),React.createElement("g",{"key":1},React.createElement("path",{"fill":"#fff","d":"M32.127 2.988H30.5c-1.279 0-1.527.631-1.527 1.558v2.043h3.05v3.2h-3.054V18h-3.182V9.789h-2.66v-3.2h2.66V4.23C25.787 1.491 27.4 0 29.75 0h2.377v2.988z","transform":"translate(17.258 13.736) translate(-22.385)"}))]);
}

FacebookInline.defaultProps = {"width":"45","height":"45","viewBox":"0 0 45 45"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
